"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idCount = 0;
function result(value) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
exports.result = result;
function has(o, k) {
    return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}
exports.has = has;
function eql(a, b) {
    return a === b;
}
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 */
function shallowEqual(objA, objB) {
    if (objA == null || objB == null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for (var i = 0; i < keysA.length; i++) {
        if (!has(objB, keysA[i]) || !eql(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}
function isShallowEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    if (typeof a !== 'object' && typeof b !== 'object') {
        return a === b;
    }
    if (typeof a !== typeof b) {
        return false;
    }
    return shallowEqual(a, b);
}
exports.isShallowEqual = isShallowEqual;
function each(obj, cb, thisArg) {
    if (Array.isArray(obj)) {
        return obj.forEach(cb, thisArg);
    }
    for (var key in obj) {
        if (has(obj, key)) {
            cb.call(thisArg, obj[key], key, obj);
        }
    }
}
exports.each = each;
function transform(obj, cb, seed) {
    each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
    return seed;
}
exports.transform = transform;
function pick(obj, keys) {
    if (keys === void 0) { keys = []; }
    return transform(obj, function (mapped, val, key) {
        if (keys.indexOf(key) !== -1) {
            mapped[key] = val;
        }
    }, {});
}
exports.pick = pick;
function pickProps(props, componentClass) {
    return pick(props, Object.keys(componentClass.propTypes));
}
exports.pickProps = pickProps;
function omit(obj, keys) {
    if (keys === void 0) { keys = []; }
    return transform(obj, function (mapped, val, key) {
        if (keys.indexOf(key) === -1) {
            mapped[key] = val;
        }
    }, {});
}
exports.omit = omit;
function omitOwnProps(component) {
    var others = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        others[_i - 1] = arguments[_i];
    }
    var keys = others.reduce(function (arr, compClass) { return arr.concat(Object.keys(compClass.propTypes)); }, Object.keys(component.constructor.propTypes));
    return omit(component.props, keys);
}
exports.omitOwnProps = omitOwnProps;
function find(arr, cb, thisArg) {
    var result;
    if (Array.isArray(arr)) {
        arr.every(function (val, idx) {
            if (cb.call(thisArg, val, idx, arr)) {
                result = val;
                return false;
            }
            return true;
        });
        return result;
    }
    else {
        for (var key in arr) {
            if (has(arr, key)) {
                if (cb.call(thisArg, arr[key], key, arr)) {
                    return arr[key];
                }
            }
        }
    }
}
exports.find = find;
function chunk(array, chunkSize) {
    var index = 0;
    var length = array ? array.length : 0;
    var result = [];
    chunkSize = Math.max(+chunkSize || 1, 1);
    while (index < length) {
        result.push(array.slice(index, (index += chunkSize)));
    }
    return result;
}
exports.chunk = chunk;
function splat(obj) {
    return obj == null ? [] : [].concat(obj);
}
exports.splat = splat;
function noop() {
    // empty
}
exports.noop = noop;
function uniqueId(prefix) {
    return '' + ((prefix == null ? '' : prefix) + (++idCount));
}
exports.uniqueId = uniqueId;
function splitComponentProps(props, Component) {
    var componentPropTypes = Component.propTypes;
    var parentProps = {};
    var childProps = {};
    Object.keys(props).forEach(function (propName) {
        if (has(props, propName)) {
            var propValue = props[propName];
            if (componentPropTypes[propName]) {
                parentProps[propName] = propValue;
            }
            else {
                childProps[propName] = propValue;
            }
        }
    });
    return [parentProps, childProps];
}
exports.splitComponentProps = splitComponentProps;
